const PREFIX_URL = `${window.APP.apiURL}/_exclusive/neo`;
const SCOPE = 'user';

export default {
  endpoints() {
    return {
      fetchNeoConfigs: id => {
        const data = { id };
        return this.post(`${PREFIX_URL}/configs`, SCOPE, { data });
      },
      fetchNeoToggles: (toggleKey, type) => {
        const data = { id: toggleKey, platform: type };
        return this.post(`${PREFIX_URL}/toggles`, SCOPE, { data });
      },
    };
  },
};
